import React from "react";
import DOMPurify from "dompurify";

const NORMALIZE_ESCAPED_TEXT = (value) => {
  return (value ?? "")
    .replace(/\\r\\n/g, "\n")
    .replace(/\\r/g, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\t/g, "    ")
    .trim();
};

const SANITIZE_OPTIONS = {
  ALLOWED_TAGS: [
    "a",
    "b",
    "br",
    "caption",
    "code",
    "col",
    "colgroup",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "i",
    "li",
    "ol",
    "p",
    "pre",
    "s",
    "span",
    "strong",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul",
    "blockquote",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "title", "class"],
  FORBID_TAGS: ["style", "script", "iframe", "object", "embed", "form"],
  // Allow relative URLs and common safe protocols.
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
};

const hardenAnchorRel = (sanitizedHtml) => {
  if (typeof window === "undefined" || !sanitizedHtml) {
    return sanitizedHtml;
  }

  const container = window.document.createElement("div");
  container.innerHTML = sanitizedHtml;

  container.querySelectorAll("a[target='_blank']").forEach((anchor) => {
    anchor.setAttribute("rel", "noopener noreferrer");
  });

  return container.innerHTML;
};

const HtmlContent = ({ html, style }) => {
  const normalizedHtml = NORMALIZE_ESCAPED_TEXT(html);
  const sanitizedHtml = DOMPurify.sanitize(normalizedHtml/* , SANITIZE_OPTIONS */);
  const safeHtml = hardenAnchorRel(sanitizedHtml);

  return (
    <div
      style={{
        whiteSpace: "pre-wrap",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        ...style,
      }}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
};

export default HtmlContent;
